import { Component, effect, Injector } from '@angular/core';
// import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';
import { ApiService } from 'src/app/services/api.service';
import { localStorageService } from 'src/app/services/localstorage.service';
import { MainService } from 'src/app/services/main.service';
import { SharedService } from 'src/app/services/shared.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-disputes',
  templateUrl: './disputes.component.html',
  styleUrl: './disputes.component.scss'
})

export class DisputesComponent {

  pfStatus = 3;
  searchString: any = '';
  allContracts = [];
  popup: Boolean = false;
  contractData: {
    "contract_id": number;
    "split_req_id": number;
    "contract_code": string;
    "last_dispute_date": string;
    pp_id: any;
    payment_process_code: any;
    status: any;
    patient_email: string;
    patient_name: string;
    patient_mobile: string;
    patient_mobile_country_code: string;
    initials:string;
    payment_id:string;
    proposal_status: string;
    contract_type : number;
  }[] = [];
  offset = 0;
  limit = 10;
  totalRecords = 0;
  totalPages: any = 0;
  selectedDisputes = 0;
  prev_search: any;
  viewId: any;
  clicklistner: any;
  currentPage: number = 1;
  mask:any
  typesFilter: statusType[] = [
    {
      key: 'All',
      value: 0
    },
    {
      key: 'New',
      value: 1
    },
    {
      key: 'Pending',
      value: 2
    },
    {
      key: 'Submitted',
      value: 3
    },
    {
      key: 'Verified',
      value: 5
    },
    {
      key: 'Need More Documents',
      value: 4
    }
  ];
  selectedType: statusType = this.typesFilter[0];
  is_loading: boolean = true;
  timezone: any;
  filter_status: number = 0
  initials: any;
  
  search_string: string = '';
  country_data: any;
  currency_data: any;
  constructor(
    public mainService: MainService,
    public router: Router,
    public _ActiveRoute: ActivatedRoute,
    private _local: localStorageService,
    private _api: ApiService,
    public _shared: SharedService,
    private location: Location,
    private injector: Injector
  ) { }

  ngOnInit() {
    this.timezone = this._shared.getCurrentTimezone();
    if (window.location.search != '') {
      this.getcontractListFromId();
    }
    effect(() => {
      const ccInfo = this._shared.country_currency_info();
      if (ccInfo && ccInfo.country) {
        this.country_data = ccInfo.country;
      }
      if (ccInfo && ccInfo.currency && ccInfo.currency.length) {
        this.currency_data = ccInfo.currency[0];
      }
    }, { injector: this.injector, allowSignalWrites: true });
    
    this._ActiveRoute.queryParams.subscribe((params) => {
      if (this.viewId != params['id']) {
        this.viewId = params['id'];
        this.getcontractListFromId()
      }
      this.filter_status = params['filter_status'];
      this.getcontractList();
    })
    this._shared.dispute_count=0
  }

  show_popup() {
    if (!this.popup) {
      setTimeout(() => {
        this.popup = true;
      }, 100)
    }
  }

  searchContract() {
    if (this.searchString || this.prev_search != this.searchString) {
      this.offset = 0;
      this.getcontractList();
    }
  }

  searchClear() {
    this.searchString = '';
    this.offset = 0;
    this.getcontractList();
  }

  getcontractList() {
    try {
      // let button = document.querySelector('.buttonlist-toggle');
      // if (button) {
      //   button['blur']();
      // }
      // let userData = this._local.customGetItem('userProfileData')
      // if (userData) {
        let data: any = {
          // access_token: userData.access_token,
          // doctor_id: userData.doctor_id,
          limit:this.limit,
          offset: this.offset,
          code: this.selectedDisputes || 0
        }
        if (this.search_string){
          data['search'] = this.search_string;
        }
        if (this.filter_status){
          data['filter_status'] = this.filter_status;
        }
        this.prev_search = this.search_string;
        this._api.api(data, 'disputes/get_doctor_disputes', 'get').subscribe((data) => {
          if (data && !data.is_error) {
            this.is_loading = false;
            this.contractData = data.contracts_list.map((item: any) => {
              return { ...item, "last_dispute_date": new Date(item.last_dispute_date) }
            });
            this._shared.dispute_count = data.disp_count; 

            this.contractData.map((data)=>{
              data.initials = this.getInitials(data.patient_name);
            })
            this.totalRecords = data.number_of_records;
            this.totalPages = data.number_of_pages;
          }
        })
      // }
    } catch (error) {
      console.log(error)
    }
  }

   getInitials(name: string): string {
    if (!name) return '';
    return name
      .split(' ')
      .map(part => part.charAt(0).toUpperCase())
      .join('');
  }
  getcontractListFromId() {
    try {
      // let button = document.querySelector('.buttonlist-toggle');
      // if (button) {
      //   button['blur']();
      // }
      let params;
      params = new URLSearchParams(window.location.search)
      this.viewId = params.get('id');
      if (!params) return;
      let userData = this._local.customGetItem('userProfileData')
      if (userData) {
        let data = {
          doctor_id: userData.doctor_id,
          limit: 10,
          offset: this.offset,
          code: this.selectedDisputes || 0,
          search: this.search_string || ""
        }
        this._api.api(data, 'disputes/get_doctor_disputes', 'get').subscribe((data) => {
          try {
            if (data.is_error) {
              this._shared.customPopups(data.err || 'Oppse something went wrong.', 1);
            }

            // if (window.location.search != '') {
            //   setTimeout(() => {
            //     if (params.get('type') == 'dispute' && data.contracts_list && data.contracts_list.length > 0) {
            //       let contract_data = { contract_id: data.contracts_list[0].contract_id, pp_id: data.contracts_list[0].pp_id, pp_subscription_id: data.contracts_list[0].pp_subscription_id, contract_code: data.contracts_list[0].contract_code, pp_code: data.contracts_list[0].payment_process_code, pp_subscription_code: data.contracts_list[0].pp_subscription_code, code: data.contracts_list[0].status.code }
            //       this.getContractDetailsDisputes(contract_data);
            //     }
            //   }, 200)
            // }
          } catch (error) {
            console.log(error);
          }
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  changePage(pageNumber: number) {
    if (this.totalRecords > 0) {
      this.offset = pageNumber * 10
      this.getcontractList();
    }
  }

//   getContractDetailsDisputes(contractId: any) {
//     try {
//       let userData = this._local.customGetItem('userProfileData')
//       if (userData) {
//         let data: any = {
//           access_token: userData.access_token,
//           doctor_id: userData.doctor_id,
//         }

//         if(contractId.pp_subscription_id){
//           console.log(contractId, 'contractId');
//           data['pp_subscription_id'] = contractId.pp_subscription_id;
//         } else {
//           data['contract_id'] = contractId.contract_id;
//           data['pp_id'] =  contractId.pp_id;
//         }
//         this._api.api(data, 'disputes/get_doctor_disputes', 'get').subscribe((data) => {
//           if (data.is_error) {
//             this._shared.customPopups(data.err || 'Oppse something went wrong.', 1);
//             return
//           }
//           let contractDocsRequired = data.documents_required.sort((a: any, b: any) => a.uploaded == 1 ? b : a);
//           let disutedPayments = data.disputed_payments;
//           this.viewContractDisputeDetails(contractId,contractDocsRequired,disutedPayments)
//         })
//       }
//     } catch (error) {
//         console.log(error)
//     }
// }
  

  viewContract(contract: any) {
    if(contract && contract.is_ar == 1 && !contract.contract_id) {
      this.router.navigate(['app/accounts-receivable/details'], { queryParams: { processId: contract.pp_id || contract.contract_id }, queryParamsHandling: "merge" })
      return;
    }
    if (contract && contract.contract_id) {
      this.router.navigate(['/app/contract/details'], { queryParams: { contractId: contract.contract_id }, queryParamsHandling: "merge" })
      return;
    }
    if (contract.payment_process_code && contract && contract.pp_id && !contract.is_arr) {
      this.router.navigate(['app/process-payment/details'], { queryParams: { processId: contract.pp_id }, queryParamsHandling: "merge" })
      return;
    }

    if (contract && contract.pp_subscription_id ) {
      // tslint:disable-next-line:max-line-length
      this.router.navigate(['app/process-payment/sub-details'], { queryParams: { processId: contract.pp_subscription_id }, queryParamsHandling: "merge" })
      return;
    }
  }


  ngAfterViewInit() {
    this.clicklistner = window.addEventListener('click', (event) => {
      if (this.popup == true && event) {
        this.popup = false;
      }
    })
  }

  ngOnDestory(){
    this.clicklistner && window.removeEventListener('click',this.clicklistner);
  }
  
  pageChanged(event: PageChangedEvent): void {
    this.currentPage = event.page;
    this.offset = (this.limit * (this.currentPage - 1));
    this.updateParams();
  }

  updateParams() {
    const url = this.router
      .createUrlTree([], {
        relativeTo: this._ActiveRoute,
        queryParams: { page_number: this.currentPage, search: this.searchString, filter_status: this.selectedType.value }
      }).toString();
    this.location.replaceState(url);
    this.getcontractList();
  }

  selectOption(option: statusType,type:string) {
    this.selectedType = option;
    this.filter_status = this.selectedType.value;
    this.updateParams();
  }

  redirectOnDetail(proposal : any){
    proposal && proposal.contract_id ? this.router.navigate(['app/contract/details'], { queryParams: { id: proposal.contract_id},
    }) : this.router.navigate(['app/customer/list'], { queryParams: { split_req_id: proposal.split_req_id},
    })  ;

    
    // this.router.navigate([url]);
  }
}

interface statusType { key: string, value: number }
